module.exports = __webpack_public_path__ + "270924301fe4a0f4cb1b77b57438c941.png";